module.exports = __webpack_public_path__ + "img/icon-advantage-2.8a4b3931.png";